/**
 * Trims a string value and returns undefined when the result is empty
 * or the input is not a string.
 * Accepts unknown to accommodate req.body fields typed as unknown.
 */
export function normalizeString(value: unknown): string | undefined {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }
  return undefined;
}

/** Alias for normalizeString; semantically signals the field is an email. */
export const normalizeEmail = normalizeString;
